import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_wrkrs_are_paid_through_3rd_party_agents_have_wrkrs_authorize'

export const dataPointDefinition = {
  retracedId: 'if_wrkrs_are_paid_through_3rd_party_agents_have_wrkrs_authorize',
  name: 'If workers are paid through 3rd party agents, have workers authorized this in writing?',
  description:
    'The intent of this question is to understand if there is written authorization in place in cases where 3rd party agents are responsible for wage payments of workers. \r\r\n\r\r\nFor example, if 3rd party agents are performing wage payments with no written authorizations in place, this option should NOT be selected.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-15--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8690,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
